<template>
  <div class="top-item">
    <router-link :to="{ name: 'videoSeries', params: { sid: item.id } }">
      <img :src="imgUrl" :alt="item.pagetitle" />
      <div class="item-overlay">
        <!-- <was-watched :video="`${item.id}`"></was-watched> -->
        <div>
          <img src="@/assets/images/inProgress.png" alt="" />
        </div>
      </div>
      <div class="mask">
        <h3>{{ item.pagetitle }}</h3>
        <div class="item-duration item-video-num" v-if="item.parent !== '10'">
          <img
            src="@/assets/images/seriesResultTag.png"
            alt=""
            style="top: 2px"
          />
          <span>{{ videoNum }}</span>
        </div>
        <div class="item-duration item-video-num" v-else>
          <img src="@/assets/images/Imunim.png" alt="" />
          <span>{{ videoNum }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  computed: {
    imgUrl() {
      if (this.item.ch) {
        return this.$store.state.initialData.basepath + this.item.ch.trim();
      }
      return "";
    },
    videoNum() {
      return `${this.item.videoItems.split("||").length} שיעורים`;
    },
  },
};
</script>

<style lang="scss">
.top-item {
  .item-video-num {
    width: 120px;
  }
}
</style>